<h1>Design</h1>

<hr>

<div class="row">
    <div class="col-4">
        <div class="bg-primary p-3 my-2">Primary</div>
    </div>
    <div class="col-4">
        <div class="bg-secondary p-3 my-2 text-light">Secondary</div>
    </div>
    <div class="col-4">
        <div class="bg-success p-3 my-2">Success</div>
    </div>
    <div class="col-4">
        <div class="bg-danger p-3 my-2">Danger</div>
    </div>
    <div class="col-4">
        <div class="bg-warning p-3 my-2">Warning</div>
    </div>
    <div class="col-4">
        <div class="bg-info p-3 my-2">Info</div>
    </div>
    <div class="col-4">
        <div class="bg-white p-3 my-2">White</div>
    </div>
    <div class="col-4">
        <div class="bg-light p-3 my-2">Light</div>
    </div>
    <div class="col-4">
        <div class="bg-dark p-3 my-2 text-light">Dark</div>
    </div>

</div>

<hr />

<h2>Headers</h2>

<h1>h1. Bootstrap heading</h1>
<h2>h2. Bootstrap heading</h2>
<h3>h3. Bootstrap heading</h3>
<h4>h4. Bootstrap heading</h4>
<h5>h5. Bootstrap heading</h5>

<hr />

<h2>Paragraph</h2>

<p [appParagraph]="1">Paragraph 1</p>
<p [appParagraph]="1" paragraphBold="true">Paragraph 1 - Bold</p>
<p [appParagraph]="2">Paragraph 2</p>
<p [appParagraph]="2" paragraphBold="true">Paragraph 2 - Bold</p>
<p [appParagraph]="3">Paragraph 3</p>
<p [appParagraph]="3" paragraphBold="true">Paragraph 3 - Bold</p>

<hr />

<h2>Lead</h2>

<p class="lead">
    This is a lead paragraph. It stands out from regular paragraphs.
</p>

<hr />

<h2>Breakpoints</h2>

<p>{{width}} px</p>

<div class="d-block d-sm-none"><h3>xs</h3></div>
<div class="d-none d-sm-block d-md-none"><h3>sm</h3></div>
<div class="d-none d-md-block d-lg-none"><h3>md</h3></div>
<div class="d-none d-lg-block d-xl-none"><h3>lg</h3></div>
<div class="d-none d-xl-block d-xxl-none"><h3>xl</h3></div>
<div class="d-none d-xxl-block"><h3>xxl</h3></div>

<hr />

<h2>Time</h2>

<p>{{timestamp | date }} px</p>

<p>Updated {{ timestamp_now === 0 ? 'today' : timestamp_now === 1 ? 'yesterday' : (timestamp | date) }}</p>
<p>Updated {{ timestamp_minus_one === 0 ? 'today' : timestamp_minus_one === 1 ? 'yesterday' : (timestamp | date) }}</p>
<p>Updated {{ timestamp_minus_ten === 0 ? 'today' : timestamp_minus_ten === 1 ? 'yesterday' : (timestamp | date) }}</p>

<hr />

<h2>Buttons</h2>

<div class="d-grid gap-2 col-12">
    <button appStandardButton>Primary</button>
    <button appSecondaryButton>Secondary</button>
    <button appWhiteButton>White</button>
    <button appLinkButton>Link</button>
</div>


<h2>Components</h2>
<h3 class="m-3">History Item</h3>

<div class="row">
    <div class="col-12 col-sm-6">
        <app-historyitem [historyitem]="historyitem" category="analysis" subcategory="money_casino"></app-historyitem>
    </div>
    <div class="col-12 col-sm-6">
        <app-historyitem [historyitem]="historyitem" category="analysis" subcategory="money_casino"></app-historyitem>
    </div>
</div>

<hr />
<h3 class="m-3">Tips</h3>

<div class="row">
    <div class="col-12 col-sm-6">
        <app-tips-tile [recommendation]="recommendation1"></app-tips-tile>
    </div>
    <div class="col-12 col-sm-6">
        <app-tips-tile [recommendation]="recommendation2"></app-tips-tile>
    </div>
</div>

<hr />
<h3 class="m-3">Recommendation</h3>

<app-recommendation-tile></app-recommendation-tile>
